module.exports = __webpack_public_path__ + "static/media/zh.1341dc21.svg";